import { render, staticRenderFns } from "./enterpriseDetail2.vue?vue&type=template&id=e671ed82&scoped=true"
import script from "./enterpriseDetail2.vue?vue&type=script&lang=js"
export * from "./enterpriseDetail2.vue?vue&type=script&lang=js"
import style0 from "./enterpriseDetail2.vue?vue&type=style&index=0&id=e671ed82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e671ed82",
  null
  
)

export default component.exports